import { useEffect, useState } from 'react';

/* Phone layout (2026-10-26): below 768px wide. Matches Bootstrap's `md` breakpoint, so screens
   built on <Col md=…> already stack at exactly this width. At 768px and above every screen
   renders exactly as it did before the mobile work — components only switch to their phone
   layout while this query matches. */
// `screen and`: a print is laid out at the paper's width (~720px on A4), which must not count as a phone.
export const MOBILE_QUERY = 'screen and (max-width: 767.98px)';

export const isMobileNow = () =>
    typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;

/* Calls cb(true|false) whenever the screen crosses the breakpoint; returns the unsubscribe. */
export function watchMobile(cb) {
    if (typeof window === 'undefined' || !window.matchMedia) return () => {};
    const mq = window.matchMedia(MOBILE_QUERY);
    let last = mq.matches;
    // Re-reads the query and reports only an actual crossing. Driven by the query's own change
    // event AND by window resize: some environments resize the viewport without firing the
    // query's change event, which left a narrowed desktop window stuck on the desktop layout.
    const check = () => {
        const now = mq.matches;
        if (now !== last) { last = now; cb(now); }
    };
    if (mq.addEventListener) mq.addEventListener('change', check); else mq.addListener(check);
    window.addEventListener('resize', check);
    return () => {
        if (mq.removeEventListener) mq.removeEventListener('change', check); else mq.removeListener(check);
        window.removeEventListener('resize', check);
    };
}

export default function useIsMobile() {
    const [mobile, setMobile] = useState(isMobileNow);
    useEffect(() => watchMobile(setMobile), []);
    return mobile;
}
